import { CheckCircle, LayoutDashboard, Timer, Globe, BookOpen, MessageSquare } from "lucide-react";
import { Link } from "react-router-dom";

const features = [
  {
    icon: LayoutDashboard,
    title: "Integrated task management",
    description: "Build Kanban boards, assign due dates and track progress. Visualizing tasks helps you stay organized and reduces cognitive load.",
    link: "/online-workspace/",
  },
  {
    icon: Timer,
    title: "Timed focus sessions",
    description: "Use Pomodoro timers and progress trackers to measure your output. Gamification elements like streaks and badges make focus fun.",
    link: "/study-timer/",
  },
  {
    icon: Globe,
    title: "Global community",
    description: "Join public or private rooms with peers worldwide. Peer interaction increases motivation and success.",
    link: "/study-with-strangers/",
  },
  {
    icon: BookOpen,
    title: "Learning tools",
    description: "Flashcards, quizzes and study notes help you review and retain information.",
    link: "/flash-cards/",
  },
  {
    icon: MessageSquare,
    title: "Collaboration & communication",
    description: "Chat, video and screen share are built in, so you don't need to juggle multiple apps.",
    link: "/group-study/",
  },
];

export const StudyverseAlternative = () => {
  return (
    <section className="py-20 px-4 relative overflow-hidden" aria-labelledby="studyverse-alt-title">
      <div className="absolute inset-0 bg-gradient-to-b from-muted/50 via-background to-muted/50" aria-hidden="true" />
      
      <div className="container mx-auto relative z-10">
        <header className="text-center mb-12 animate-fade-in">
          <h2 id="studyverse-alt-title" className="font-display text-4xl md:text-5xl font-bold mb-6 bg-gradient-to-r from-primary via-secondary to-primary bg-clip-text text-transparent">
            Studyverse Alternative
          </h2>
          <p className="text-lg text-muted-foreground max-w-3xl mx-auto leading-relaxed">
            If you've tried platforms like Studyverse, you'll appreciate what CSW brings to the table. While Studyverse focuses on simple co-studying, CSW offers a full productivity suite:
          </p>
        </header>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-5xl mx-auto mb-12">
          {features.map((feature, index) => {
            const Icon = feature.icon;
            return (
              <Link
                key={feature.title}
                to={feature.link}
                className="group flex items-start gap-4 p-5 rounded-xl bg-card border border-border hover:border-primary/50 transition-all duration-300 hover:shadow-md animate-fade-in"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0 group-hover:bg-primary/20 transition-colors">
                  <Icon className="w-5 h-5 text-primary" />
                </div>
                <div>
                  <h3 className="font-bold text-foreground mb-1">{feature.title}</h3>
                  <p className="text-sm text-muted-foreground leading-relaxed">{feature.description}</p>
                </div>
              </Link>
            );
          })}
        </div>

        <div className="text-center">
          <Link 
            to="/studyverse/" 
            className="inline-flex items-center gap-2 text-primary hover:text-primary/80 font-semibold transition-colors"
          >
            Learn more about CSW vs Studyverse →
          </Link>
        </div>
      </div>
    </section>
  );
};